<template>
  <div class="wrapper">
    <dt class="label">
      <slot name="label" />
    </dt>
    <dd class="value">
      <slot name="value" />
    </dd>
  </div>
</template>

<style scoped>
.wrapper
{
  @apply py-4 sm:py-5 sm:px-6;
  @apply sm:grid sm:grid-cols-4 sm:gap-4;
}

.label
{
  @apply text-sm font-medium text-gray-500;
}

.value
{
  @apply mt-1 sm:mt-0 sm:col-span-3;
  @apply text-sm text-gray-900;
}
</style>
